/**
 * BANK-IBAN-R3.9 — PDP seed timing (staging owner diagnostics only).
 */
export type PdpPerfMark =
  | "product_tap_ts"
  | "pdp_route_ts"
  | "pdp_seed_render_ts"
  | "pdp_detail_ready_ts";

const marks: Partial<Record<PdpPerfMark, number>> = {};

export function markPdpPerf(name: PdpPerfMark, ts = performance.now()): void {
  if (marks[name] == null) marks[name] = ts;
  try {
    (window as unknown as { __AS_PDP_PERF?: Record<string, number> }).__AS_PDP_PERF = {
      ...marks,
    } as Record<string, number>;
  } catch {
    /* ignore */
  }
}

export function resetPdpPerf(): void {
  for (const k of Object.keys(marks) as PdpPerfMark[]) delete marks[k];
}

export function readPdpPerf(): Partial<Record<PdpPerfMark, number>> {
  return { ...marks };
}

export function pdpSeedMs(): number | null {
  if (marks.product_tap_ts == null || marks.pdp_seed_render_ts == null) return null;
  return Math.round(marks.pdp_seed_render_ts - marks.product_tap_ts);
}

export function pdpTimings(): {
  tap_to_route_ms: number | null;
  tap_to_seed_paint_ms: number | null;
  tap_to_detail_ms: number | null;
} {
  const tap = marks.product_tap_ts;
  return {
    tap_to_route_ms:
      tap != null && marks.pdp_route_ts != null ? Math.round(marks.pdp_route_ts - tap) : null,
    tap_to_seed_paint_ms:
      tap != null && marks.pdp_seed_render_ts != null ? Math.round(marks.pdp_seed_render_ts - tap) : null,
    tap_to_detail_ms:
      tap != null && marks.pdp_detail_ready_ts != null ? Math.round(marks.pdp_detail_ready_ts - tap) : null,
  };
}
